export const EARLY_AVATAR_DEFAULT = 'early_avatar_default'
export const SUBMIT_BUTTON = 'submit_button'

export const ZERO_BALANCE_MODAL_LINK = 'zero_balance_modal_link'

export const UNVERIFIED_FUNDING_MODAL_LINK =
  'unverified_funding_modal_settings_link'

export const NO_FUNDING_MODAL_LINK = 'no_funding_modal_settings_link'

export const LOAD_MORE_ITEMS = 'load_more_items'

export const CONFIRM_INVEST_MODAL = 'confirm_invest_modal'
export const CONFIRM_INVESTMENT_SUCCES_MODAL = 'confirm_investment_succes_modal'
export const CONFIRM_INVESTMENTS_PAUSED_MODAL =
  'confirm_investments_paused_modal'
export const CONFIRM_PROMPT_RECURRING_MODAL = 'confirm_prompt_recurring_modal'

export const CONFIRM_WITHDRAW_ERROR_UNVERIFIED_FUNDING_SOURCE_MODAL =
  'confirm_withdraw_error_unverified_funding_source_modal'
export const CONFIRM_WITHDRAW_AMOUNT_EXCEEDS_BALANCE_MODAL =
  'confirm_withdraw_amount_exceeds_balance_modal'
export const CONFIRM_LIQUIDATION_MODAL = 'confirm_liquidation_modal'
export const CONFIRM_UNVERIFIED_FUNDING_SOURCE_MODAL =
  'confirm_unverified_funding_source_modal'
export const CONFIRM_ZERO_BALANCE_MODAL =
  'confirm_withdraw_amount_exceeds_balance_modal'

export const CONFIRM_NO_FUNDING_SOURCE_MODAL = 'confirm_no_funding_source_modal'
export const CONFIRM_FAILURE_MODAL = 'confirm_failure_modal'
